
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Switch from '@/components/switch.vue'
	import previewImg from '@/components/previewImg.vue';
  import {
    livemallLiveConfig,
    liveliveRoomSelectItem,
    livemallLiveConfigSave
  } from "@/api/auth"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'rt-switch':Switch,
      previewImg,
    }
  })

  export default class ProductList extends Vue {
    private form:any = {
      IsShowLiveEntrance:false,
      LiveRoomId:'',
    }
    private livelist:any = []
    private showPreview = false

    private mounted () {
      this.getinfo()
    }

    private async changeshowlive(e){
      this.form.LiveRoomId = ''
      if(e){
        await this.getliveroom()
        // console.log(this.livelist)
        let nostarted = this.livelist
        .filter(v=>{
          return v.LiveStatus == 102
        }).map(v=>{
          v.time = new Date(v.StartTime).getTime() - new Date().getTime()
          return v
        }).sort((a,b)=>{
          return a.time - b.time
        }).map(v=>v.Id)
        if(nostarted&&nostarted.length){
          this.form.LiveRoomId = nostarted[0] || ''
        }else{
          let started = this.livelist.filter(v=>{
          return v.LiveStatus == 101
        }).map(v=>v.Id)
          this.form.LiveRoomId = started[0] || ''
        }
      }
    }
    private testform(){
      return true
    }
    private async getliveroom(){
      try{
        let res = await liveliveRoomSelectItem({})
        if(res.IsSuccess){
          this.livelist = res.Result
        }
      }finally{
        //
      }
    }
    private async getinfo(){
      try{
        await this.getliveroom()
        let res = await livemallLiveConfig({})
        if(res.IsSuccess){
          this.form = res.Result
          if(!this.livelist.find(v=>v.Id==this.form.LiveRoomId)?.Id){
            this.form.LiveRoomId = ''
          }
        }
      }finally{
        //
      }
    }
    private async submit(){
      if(!this.testform()){
        this.$message.error('')
        return false
      }
      try{
        let form = JSON.parse(JSON.stringify(this.form))
        if(!form.IsShowLiveEntrance){
          form.LiveRoomId = ''
        }
        let res = await livemallLiveConfigSave(this.form)
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.getinfo()
        }
      }finally{
        //
      }
    }
  }
